import React from 'react';
import styles from '../mini-dialog.module.css.js';

function ToggleTextButton({ hideText, hideTextTitle, showTextTitle, onClick, }) {
    return (React.createElement("button", { type: 'button', title: hideText ? showTextTitle : hideTextTitle, className: styles.optionText, onClick: onClick },
        React.createElement("i", { className: `bc-icon bc-icon-capital-t${hideText ? '-strike-through' : ''}`, role: 'img' })));
}

export { ToggleTextButton };
